import { getOneXpExperiments } from 'src/universal/redux/oneXp';
import { getActiveFilter, DEFAULT_FILTER } from 'src/universal/redux/cardsFilter';
import { getExperimentalPageData } from 'src/universal/redux/page';
import { createSelector } from 'reselect';

export const tncKeys = ['offerTerms', 'ratesFees'];

export const isG176Variant = createSelector(
  [getOneXpExperiments, getActiveFilter],
  (oneXpExperiments, activeFilter) => {
    const isVariant =
      oneXpExperiments['GCS-176-VAC-Dynamic-Hero']?.dimensions[0]?.variant ===
      'experiment';

    //US5635729: We do not show variant banner for default filter.
    return activeFilter !== DEFAULT_FILTER && isVariant;
  }
);

export const getCombinedG176Data = createSelector(
  [isG176Variant, getExperimentalPageData, getActiveFilter],
  (g176Variant, { g176DynamicHero }, activeFilter) => {
    const matchedItem = (g176DynamicHero?.content || []).find(item => {
      return item.filterKey === activeFilter;
    });
    const content = { ...matchedItem };
    return {
      isG176Variant: g176Variant,
      staticG176Data: g176DynamicHero,
      content
    };
  }
);
